// generate a array of years since 2013

var graduationYears = [];
for (var i = 2013; i <= new Date().getFullYear(); i++) {
  graduationYears.push(i);
}

export default graduationYears;
